/**
 * 808.VISION — Limit one per cart
 * Blocks the *resulting* quantity of a restricted product from exceeding 1,
 * across /cart/add, /cart/change and /cart/update calls (covers add-to-cart,
 * the cart page's "+" stepper, and bulk quantity updates).
 * Product handles to restrict are set via window.LIMIT_ONE_HANDLES (Shopify section).
 */
(function () {
  function getHandles() {
    var raw = window.LIMIT_ONE_HANDLES || '';
    return raw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  }

  var handles = getHandles();
  if (!handles.length) return;

  var variantMap = {}; // variantId -> handle
  var productsLoadedPromise = null;

  function ensureProductsLoaded() {
    if (productsLoadedPromise) return productsLoadedPromise;
    productsLoadedPromise = Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (!product) return;
            product.variants.forEach(function (v) {
              variantMap[v.id] = handle;
            });
          })
          .catch(function () {});
      })
    );
    return productsLoadedPromise;
  }

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function showBlockedToast() {
    var existing = document.getElementById('limit808-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.id = 'limit808-toast';
    toast.textContent = 'Only 1 per order — this item is already in your cart.';
    toast.style.cssText =
      'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);' +
      'background:#111111;color:#FFFFFF;padding:14px 22px;border-radius:8px;' +
      'font:600 13px -apple-system,Arial,sans-serif;letter-spacing:.01em;' +
      'z-index:99999;box-shadow:0 12px 30px rgba(0,0,0,0.25);max-width:90vw;text-align:center;';
    document.body.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 3500);
  }

  // Fake a normal Shopify error Response instead of rejecting the fetch —
  // themes expect a resolved Response (even for errors) and often leave the
  // "Add to cart" button stuck loading forever if the fetch promise rejects.
  function blockedResponse() {
    var body = JSON.stringify({
      status: 422,
      message: 'Only 1 per order',
      description: 'This item is limited to 1 per order.'
    });
    return new Response(body, {
      status: 422,
      statusText: 'Unprocessable Entity',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  function parseBody(body) {
    if (body == null) return null;
    if (body instanceof FormData) {
      var obj = {};
      body.forEach(function (value, key) { obj[key] = value; });
      return obj;
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) {}
      try {
        var obj2 = {};
        new URLSearchParams(body).forEach(function (value, key) { obj2[key] = value; });
        return obj2;
      } catch (e2) {}
    }
    return null;
  }

  function variantIdFromKey(idValue) {
    if (idValue == null) return null;
    var str = String(idValue);
    return Number(str.indexOf(':') !== -1 ? str.split(':')[0] : str);
  }

  // Compute what the total restricted-product quantity WOULD BE if this
  // mutation (add / change / update) were applied, without actually applying it.
  function computeResultingTotal(kind, payload, cart) {
    var perVariant = {};
    cart.items.forEach(function (item) {
      perVariant[item.variant_id] = (perVariant[item.variant_id] || 0) + item.quantity;
    });

    if (kind === 'add') {
      var items = Array.isArray(payload.items) ? payload.items : [payload];
      items.forEach(function (it) {
        var vid = Number(it.id);
        var qty = Number(it.quantity) || 1;
        perVariant[vid] = (perVariant[vid] || 0) + qty;
      });
    } else if (kind === 'change') {
      var vid2 = variantIdFromKey(payload.id);
      var targetLine = null;
      if (payload.line) targetLine = cart.items[Number(payload.line) - 1];
      else targetLine = cart.items.find(function (it) { return it.variant_id === vid2 || it.key === String(payload.id); });
      if (targetLine) {
        var oldQty = targetLine.quantity;
        var newQty = Number(payload.quantity) || 0;
        perVariant[targetLine.variant_id] = (perVariant[targetLine.variant_id] || 0) - oldQty + newQty;
      }
    } else if (kind === 'update') {
      var updates = payload.updates || {};
      Object.keys(updates).forEach(function (key) {
        var vid3 = variantIdFromKey(key);
        var targetLine2 = cart.items.find(function (it) { return it.variant_id === vid3 || it.key === key; });
        var oldQty2 = targetLine2 ? targetLine2.quantity : 0;
        var newQty2 = Number(updates[key]) || 0;
        perVariant[vid3] = (perVariant[vid3] || 0) - oldQty2 + newQty2;
      });
    }

    var total = 0;
    Object.keys(perVariant).forEach(function (vid) {
      if (variantMap[vid]) total += perVariant[vid];
    });
    return total;
  }

  function mutationKind(url) {
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) return 'add';
    if (/\/cart\/change(\.js)?(\?|$)/.test(url)) return 'change';
    if (/\/cart\/update(\.js)?(\?|$)/.test(url)) return 'update';
    return null;
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var kind = mutationKind(url);

    if (!kind || !init || init.body == null) {
      return originalFetch.apply(this, arguments);
    }

    var payload = parseBody(init.body);
    if (!payload) return originalFetch.apply(this, arguments);

    var self = this;
    var args = arguments;

    return ensureProductsLoaded()
      .then(getCart)
      .then(function (cart) {
        var resultingTotal = computeResultingTotal(kind, payload, cart);
        if (resultingTotal > 1) {
          showBlockedToast();
          return blockedResponse();
        }
        return originalFetch.apply(self, args);
      });
  };

  // Fallback for classic (non-AJAX) form submissions to /cart/add
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    var kind = mutationKind(form.action);
    if (kind !== 'add') return;
    if (form.dataset.limit808Checked === 'true') {
      delete form.dataset.limit808Checked;
      return;
    }

    var payload = parseBody(new FormData(form));
    if (!payload) return;

    e.preventDefault();
    ensureProductsLoaded()
      .then(getCart)
      .then(function (cart) {
        var resultingTotal = computeResultingTotal('add', payload, cart);
        if (resultingTotal > 1) {
          showBlockedToast();
        } else {
          form.dataset.limit808Checked = 'true';
          form.submit();
        }
      });
  }, true);

  ensureProductsLoaded();
})();
